export const defaultBasePath = 'https://${backend}/api/rest/web/v2';
